import { retryPendingDraftCleanup } from "./draftCleanupObligations";
import { draftRepository, DraftStorageError } from "./draftRepository";

const MAINTENANCE_INTERVAL_MS = 24 * 60 * 60 * 1000;

interface ActiveMaintenance {
  owners: number;
  timer: ReturnType<typeof setInterval>;
}

let activeMaintenance: ActiveMaintenance | null = null;

const removeExpiredDrafts = async (): Promise<void> => {
  try {
    await retryPendingDraftCleanup();
    const result = await draftRepository.removeExpired(Date.now());
    if (result instanceof DraftStorageError) {
      console.warn("composer_draft_maintenance_failed", result.kind);
    }
  } catch {
    console.warn("composer_draft_maintenance_failed", "unavailable");
  }
};

export const startComposerDraftMaintenance = (): (() => void) => {
  if (activeMaintenance) {
    activeMaintenance.owners += 1;
  } else {
    void removeExpiredDrafts();
    activeMaintenance = {
      owners: 1,
      timer: setInterval(() => {
        void removeExpiredDrafts();
      }, MAINTENANCE_INTERVAL_MS),
    };
  }

  let stopped = false;
  return () => {
    if (stopped || !activeMaintenance) return;
    stopped = true;
    activeMaintenance.owners -= 1;
    if (activeMaintenance.owners > 0) return;

    clearInterval(activeMaintenance.timer);
    activeMaintenance = null;
  };
};
